import React, { useState } from "react";
import { useRef } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Parallax } from 'react-parallax';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";

const Facilities_Services = (props) => {
  const sectionTitle = props.val.facilities_tag.split(' ');
  const [prevNav, setPrevNav] = useState(false);
  const [nextNav, setNextNav] = useState(true);
  const sliderRef = useRef(null);

  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 2.5,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   swipeToSlide: true,
  //   initialSlide: 0,

  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 2.5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2.5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 360,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // };
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    afterChange: current => {
      if (current === 0) {
        setPrevNav(false);
        setNextNav(true);
      }
      else if (current === (props.val.blc_facilites.length - 3.2)) {
        setNextNav(false);
        setPrevNav(true);
      }
      else {
        setNextNav(true);
        setPrevNav(true);
      }
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      {/* <Parallax bgImage="https://blcload.brac.net/DJI_0862_00_01_36_25_Still006_edff10c80b_8885798a97/DJI_0862_00_01_36_25_Still006_edff10c80b_8885798a97.jpg?updated_at=2022-09-07T21:03:38.616Z" strength={100}> */}
      {/* <Container className="dark-overlay" fluid> */}
      <>
        <section id="facilities-slider">
          <Container >
            <div className="slider-heading" style={{ width: '98%' }}>
              {/* <h2 className="services-txt  text-start">{props.val.facilities_tag}</h2> */}
              <h2 className="titles">
                <span className='titles-black'>{sectionTitle[1]}</span>
                <span className='titles-black'> {sectionTitle[2]}</span>
                <span className=""> {sectionTitle[3]}</span>
              </h2>
              <div className="slider-nav-container">
                {
                  prevNav && <div className="slider-navBtn" >
                    <IoChevronBackOutline size={20} onClick={() => sliderRef.current.slickPrev()} />
                  </div>
                }
                {
                  nextNav && <div className="slider-navBtn" >
                    <IoChevronForwardOutline size={20} onClick={() => sliderRef.current.slickNext()} />
                  </div>
                }
              </div>
            </div>

            <div className="custom-padding-container row-full">
              <Slider ref={sliderRef} {...settings} className="blccard-card">
                {props.val.blc_facilites.map((data, idx) => (<div
                  key={idx}
                  className='pe-3'>
                  <Card className="slider-card card-bg">
                    <Card.Img src={data.blc_facilites_img.data[0].attributes.formats.medium.url} className='blccard' alt="Card image" />
                    <Card.ImgOverlay style={{ paddingRight: '0px', paddingLeft: '0px' }}>
                      <p className="slider-card-title"><b>{data.blc_facilites_text}</b></p>
                    </Card.ImgOverlay>
                  </Card>
                </div>
                ))}
              </Slider>
            </div>

          </Container>
        </section>
        {/* <Parallax bgImage="https://blcload.brac.net/DJI_0862_00_01_36_25_Still006_edff10c80b_8885798a97/DJI_0862_00_01_36_25_Still006_edff10c80b_8885798a97.jpg?updated_at=2022-09-07T21:03:38.616Z" strength={100}>
            <Container className="dark-overlay" fluid>
              <Container className="py-5">
                <div className="justify-content-center">
                  <h2 className="services-txt ">{props.val.facilities_tag}</h2>
                  <div>
                    <Row md={8} sm={4} xs={1}>
                      {props.val.blc_facilites.map((data, idx) => (
                        <Col className="mb-3" lg={3} md={3} sm={3} key={idx}>
                          <Card className="pricing-animation card-bg" style={{ width: '100%' }}>
                            <Card.Img src={data.blc_facilites_img.data[0].attributes.formats.medium.url} height="200" alt="Card image" />
                            <Card.ImgOverlay style={{ paddingRight: '0px', paddingLeft: '0px' }}>
                              <div className="bottom-caption">
                                <p className="text-center fix-center"><b>{data.blc_facilites_text}</b></p>
                              </div>
                            </Card.ImgOverlay>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </Container>
            </Container>
          </Parallax> */}
      </>
      {/* </Parallax> */}


    </>
  );
};

export default Facilities_Services;